var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.problem)?_c('div',{staticClass:"problem"},[(Array.isArray(_vm.problem))?_vm._l((_vm.problem),function(p){return _c('div',[_vm._v(_vm._s(p))])}):_c('div',[_vm._v(_vm._s(_vm.problem))])],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }